import styles from './InfoCard.module.scss';

const InfoCard = ({ icon, label, value }) => {
  return (
    <div className={styles.infoCard}>
      <div className={styles.infoIcon}>
        <img src={icon} alt='' />
      </div>
      <div className={styles.infoText}>
        <p className={styles.infoLabel}>{label}</p>
        <p className={styles.infoValue}>{value || '—'}</p>
      </div>
    </div>
  );
};

export default InfoCard;
